import { render, staticRenderFns } from "./line-separator.vue?vue&type=template&id=204e2f11&scoped=true&"
import script from "./line-separator.vue?vue&type=script&lang=js&"
export * from "./line-separator.vue?vue&type=script&lang=js&"
import style0 from "./line-separator.vue?vue&type=style&index=0&id=204e2f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e2f11",
  null
  
)

export default component.exports